import React from 'react';
import toast from 'react-hot-toast';

// The petals of the ArtWeaver logo, one hue each.
const PETAL_COLORS = ['#ef4444', '#f97316', '#eab308', '#22c55e', '#3b82f6', '#a855f7'];

export function ArtWeaverLogo({ className = 'h-5 w-5' }) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
      {PETAL_COLORS.map((color, index) => (
        <ellipse
          key={color}
          cx="16"
          cy="8"
          rx="5"
          ry="8"
          fill={color}
          opacity="0.9"
          transform={`rotate(${index * 60} 16 16)`}
        />
      ))}
      <circle cx="16" cy="16" r="3" fill="#fff" />
    </svg>
  );
}

/**
 * Opens the lesson's worksheet (`item`, its PDF content item) with `onOpen(item)`, or says there
 * isn't one when the lesson has no PDF. `title` is the lesson's.
 */
export function OpenPdfButton({ title, item, onOpen, className = '' }) {
  const handleClick = () => {
    if (item) onOpen(item);
    else toast('Worksheet not uploaded yet', { icon: '🚧' });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={`Open PDF: ${title}`}
      className={`flex items-center justify-center gap-2 rounded-xl border-2 border-gray-200 bg-white px-4 py-2.5 text-sm font-extrabold text-rose-600 shadow-sm transition-colors hover:bg-rose-50 ${className}`}
    >
      <span aria-hidden="true" className="rounded bg-red-500 px-1 py-0.5 text-[9px] font-black leading-none text-white">
        PDF
      </span>
      Open PDF
    </button>
  );
}

/**
 * `soft` is the pale pink button on each list row; `solid` is the strong one in
 * a lesson's drawing page header. `title` is the lesson's.
 */
export function OpenArtWeaverButton({ title, onClick, variant = 'soft', className = '' }) {
  const tone =
    variant === 'solid'
      ? 'bg-pink-600 text-white shadow-sm hover:bg-pink-700'
      : 'bg-pink-50 text-pink-600 hover:bg-pink-100';

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={`Open ArtWeaver: ${title}`}
      className={`flex items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-extrabold transition-colors ${tone} ${className}`}
    >
      <span className={variant === 'solid' ? 'rounded-full bg-white p-0.5' : ''}>
        <ArtWeaverLogo />
      </span>
      Open ArtWeaver
    </button>
  );
}
